import { getHotTableElementFromHotInstance, getTableElementFromHotInstance } from './hotTableDomAccessorUtils';
import { MNHotInstance } from '../../tableHotInstanceTypes';

/**
 * Directly updates the rendered table element width, bypassing the normal table component width flow.
 */
export const dangerouslySetTableElementWidthPx = (hotInstance: MNHotInstance, width: number): void => {
    const tableElement = getTableElementFromHotInstance(hotInstance);
    if (tableElement) tableElement.style.width = `${width}px`;
};

/**
 * Adds a class directly to the outer Milanote table element.
 */
export const addClassToTableElement = (hotInstance: MNHotInstance, className: string): void => {
    const tableElement = getTableElementFromHotInstance(hotInstance);
    if (tableElement) tableElement.classList.add(className);
};

/**
 * Removes a class directly from the outer Milanote table element.
 */
export const removeClassFromTableElement = (hotInstance: MNHotInstance, className: string): void => {
    const tableElement = getTableElementFromHotInstance(hotInstance);
    if (tableElement) tableElement.classList.remove(className);
};

/**
 * Adds a class directly to the `.HotTable` wrapper element.
 */
export const addClassToHotTable = (hotInstance: MNHotInstance, className: string): void => {
    const hotTableElement = getHotTableElementFromHotInstance(hotInstance);
    if (hotTableElement) hotTableElement.classList.add(className);
};

/**
 * Removes a class directly from the `.HotTable` wrapper element.
 */
export const removeClassFromHotTable = (hotInstance: MNHotInstance, className: string): void => {
    const hotTableElement = getHotTableElementFromHotInstance(hotInstance);
    if (hotTableElement) hotTableElement.classList.remove(className);
};
